"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SendsRemainingBadge = function (props) {
    var _a, _b;
    var color = "";
    if (props.sendsRemaining !== undefined) {
        color = props.sendsRemaining > 2 ? "#28a745" : props.sendsRemaining > 1 ? "#ff7900" : "#ff0000";
    }
    var badgeWidth = 20;
    if (((_a = props.sendsRemaining) === null || _a === void 0 ? void 0 : _a.toString().length) !== undefined) {
        badgeWidth += ((((_b = props.sendsRemaining) === null || _b === void 0 ? void 0 : _b.toString().length) - 1) * 7);
    }
    return (React.createElement("span", { style: { display: "inline-flex", justifyContent: "center", alignItems: "center", minWidth: "30px", width: badgeWidth + "px", height: "30px", borderRadius: "100px", color: "white", backgroundColor: color, fontSize: "1.1rem", fontWeight: 500 } }, props.sendsRemaining));
};
exports.default = SendsRemainingBadge;
//# sourceMappingURL=SendsRemainingBadge.js.map